import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import { getList } from "@/api/notice";
import showNoticeMsg from "./showNoticeMsg.vue";
import infoList from "@/mixins/infoList";
import { getChannelMap } from "@/utils/dictionary";
import { formatTimeToStr } from "@/utils/date.js";
export default {
  components: {
    showNoticeMsg: showNoticeMsg
  },
  name: "showNoticeTable",
  mixins: [infoList],
  data: function data() {
    return {
      type: {
        1: "登录公告",
        2: "活动公告",
        3: "系统公告",
        4: "小报",
        5: "开服公告",
        6: "更新公告",
        7: "游戏声明"
      },
      status: {
        0: "关闭",
        1: "开启"
      },
      channelMap: {},
      dialogFormVisible: false,
      infoMsg: {},
      listApi: getList,
      searchInfo: {},
      tableData: [],
      nowStr: ''
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getChannelMap();
          case 2:
            _this.channelMap = _context.sent;
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {
    this.$emit('ready');
  },
  methods: {
    loadTatleData: function loadTatleData(m) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.nowStr = formatTimeToStr(new Date());
              _this2.searchInfo = m;
              _this2.loading = true;
              _context2.next = 5;
              return _this2.getTableData(1);
            case 5:
              _this2.loading = false;
              if (!_this2.tableData || _this2.tableData && _this2.tableData.length === 0) {
                _this2.$message({
                  message: "公告列表，暂无数据"
                });
              }
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    checkBtn: function checkBtn(e) {
      this.infoMsg = e;
      this.dialogFormVisible = true;
    },
    editBtn: function editBtn(e) {
      this.$emit("goEditBtn", e);
    },
    getChannelLable: function getChannelLable(item) {
      var id = item.channel_id;
      var label = this.channelMap[id] || '??';
      return "".concat(label, "\uFF08").concat(id, "\uFF09");
    },
    getTimeStatusLabel: function getTimeStatusLabel(row) {
      if (row.end_time < this.nowStr) {
        return '已过期';
      } else if (row.start_time > this.nowStr) {
        return '未生效';
      } else if (row.start_time <= this.nowStr && this.nowStr <= row.end_time) {
        return '生效中';
      }
    },
    getTimeStatusColor: function getTimeStatusColor(row) {
      if (row.end_time < this.nowStr) {
        return 'red';
      } else if (row.start_time > this.nowStr) {
        return 'gray';
      } else if (row.start_time <= this.nowStr && this.nowStr <= row.end_time) {
        return 'green';
      }
    }
  }
};